<app-form-group>
    <nz-alert nzType="error" [nzDescription]="dangerTpl" class="mb-1" nzShowIcon>
        <ng-template #dangerTpl>
            <div [innerHTML]="'ANNEX.PROTECTION_PERIOD_CORRECTION_WARNING' | translate | appSanitizeHtml"></div>
        </ng-template>
    </nz-alert>
    <nz-alert nzType="info" [nzDescription]="infoTpl" class="mb-1" nzShowIcon>
        <ng-template #infoTpl>
            <div [innerHTML]="'ANNEX.PROTECTION_PERIOD_CORRECTION_FILE_INFO' | translate | appSanitizeHtml"></div>
        </ng-template>
    </nz-alert>
    <app-uploader
        (listChange)="fileListChanged($event)"
        [extensions]="extensions"
        [errors]="fileControl.errors"
        [multiple]="false"
    ></app-uploader>
    @if (results()) {
        <app-section-view label="ANNEX.PROTECTION_PERIOD_CORRECTION_RESULT_HEADER"></app-section-view>
        <nz-table #errorTable [nzData]="results()" [nzFrontPagination]="false" class="mt-1">
            <thead>
                <tr>
                    <th>{{ 'LABELS.POLICY_NUMBER' | translate }}</th>
                    <th>{{ 'LABELS.POLICY_CONCLUSION' | translate }}</th>
                    <th>{{ 'ANNEX.START' | translate }}</th>
                    <th>{{ 'ANNEX.STOP' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                @for (item of errorTable.data; track item.policyNumber) {
                    <tr>
                        <td>
                            {{ item.policyNumber }}
                        </td>
                        <td>{{ item.conclusion | lsnDate | emptyValue }}</td>
                        <td>{{ item.start | lsnDate | emptyValue }}</td>
                        <td>{{ item.stop | lsnDate | emptyValue }}</td>
                    </tr>
                }
            </tbody>
        </nz-table>
    }
</app-form-group>
